import { dwellsyApi } from "api/dwellsy";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { Card } from "shared/components/Card";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { IntegrationLogoIcon } from "views/settings-integration/components/IntegrationLogoIcon";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const DwellsyView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();

  const { mutate: disconnectDwellsy, isPending: isDisconnecting } = useMutation(
    {
      mutationKey: ["DWELLSY", "DELETE"],
      mutationFn: () => dwellsyApi.disconnect(),
      onSuccess: () => {
        toast.success("Dwellsy integration disconnected successfully");
        refreshPartnerData();
        navigate("/settings/integration");
      },
      onError: (err) => {
        toast.error(getErrorMessage(err));
      }
    }
  );

  return (
    <Layout
      header={
        <>
          <div className="flex items-center justify-between border-b border-alpha-40 px-3 md:px-6 pb-3">
            <BreadCrumbs
              crumbs={[
                { title: "Settings", href: "/settings" },
                { title: "Integration", href: "/settings/integration" },
                { title: "Dwellsy", href: "/settings/integration/dwellsy" }
              ]}
            />
          </div>
          <div className="flex items-center justify-between px-6 py-4 border-b border-alpha-40">
            <div className="flex items-center gap-4">
              <IntegrationLogoIcon id={IntegrationId.DWELLSY} size="SM" />
              <p className="text-xl font-bold text-content-1000">Dwellsy</p>
            </div>
            <Button
              variant={ButtonVariant.BASE}
              size={ButtonSize.SM}
              HugeIcon={Cancel01Icon}
              onClick={() => disconnectDwellsy()}
              loading={isDisconnecting}
            >
              Disconnect
            </Button>
          </div>
        </>
      }
    >
      <Card className="w-full p-6 max-w-[800px]">
        <p className="text-base font-bold text-content-1000">
          Dwellsy Integration
        </p>
        <p className="mt-2 text-sm text-content-400">
          Your listings are being published to Dwellsy&apos;s rental
          marketplace. To stop publishing, disconnect this integration.
        </p>
      </Card>
    </Layout>
  );
};
